import { Grid, Paper, Button } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import useReactHookForm from "hooks/useReactHookForm";
import ContentRight from "shared/molecules/content-right";
import { useEffect } from "react";
import { hasAtLeastOneValue, initialValues, properties, validationSchema } from "./helper";
import { formatDateUtc } from "utils/time-util/utcIstTime";

export function Nl3LiveclassGroupPackageSubscribersFilter({ setSearchPayload, setPage, clearValuesTrigger }) {
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    initialValues,
    validationSchema,
    "",
  );


  const handleSearch = () => {
    const payload: any = {};
    const values = watch();

    if (values.nlearn3LiveclassPackageId) {
      payload.liveclassPackageId = Number(values.nlearn3LiveclassPackageId);
    }
    if (values.admissionNumber) payload.admissionNumber = values.admissionNumber;
 
    if (values.isArchived === "true") payload.isArchived = true;
    else if (values.isArchived === "false") payload.isArchived = false;

    if (values.created_at?.[0]) payload.createdFrom = formatDateUtc(values.created_at[0]);
    if (values.created_at?.[1]) payload.createdTill = formatDateUtc(values.created_at[1], true);

    if (values.updated_at?.[0]) payload.updatedFrom = formatDateUtc(values.updated_at[0]);
    if (values.updated_at?.[1]) payload.updatedTill = formatDateUtc(values.updated_at[1], true);

    setSearchPayload(payload);
    setPage(1);
  }


  const clearFilter = () => {
    setValue("nlearn3LiveclassPackageId", "");
    setValue("admissionNumber", "");
    setValue("isArchived", "");
    setValue("created_at", [null, null]);
    setValue("updated_at", [null, null]);
    setSearchPayload({});
    setPage(1);
  }

  useEffect(() => {
    clearFilter()
  }, [clearValuesTrigger])

  
  return (
    <div>
      <Paper elevation={2} sx={{ px: 2, pb: 3, pt: 3 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={properties}
            control={control}
            errors={errors}
            watch={watch}
            setValue={setValue}
            getValues={getValues}
          />

          <ContentRight sx={{ mt: -7 }}>
            <Button
              variant="contained"
              sx={{
                width: "70px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={clearFilter}
              disabled={!hasAtLeastOneValue(watch(), ["nlearn3LiveclassPackageId", "admissionNumber", "isArchived", "created_at", "updated_at"]) || Object.keys(errors).length > 0}
            >
              clear
            </Button>
            <Button
              variant="contained"
              sx={{
                width: "80px",
                height: "40px",
                marginTop: "15px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleSearch}
              disabled={!hasAtLeastOneValue(watch(), ["nlearn3LiveclassPackageId", "admissionNumber", "isArchived", "created_at", "updated_at"]) || Object.keys(errors).length > 0}
            >
              search
            </Button>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
}
